<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :model="formState" ref="formRef">
      <a-form-item label="审核意见">
        <a-textarea v-model:value="formState.issue" auto-size></a-textarea>
      </a-form-item>

      <a-form-item
        label="变更文件"
        v-if="modalConfig.record && modalConfig.record.nodeName === '发起评审'"
      >
        <upload
          :echoFile="modalConfig.record.annex"
          @setUploadFileUrl="setUploadFileUrl"
        ></upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
   
<script>
import { defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import websocket from "@/utils/base/socket";
import { saveApprovalNode } from "@/request/view/project";
import { timeStampToTime } from "@/utils/index";
import { updateDesignChanges } from "@/request/view/project";
import { getEngineeringDepartment, getStrctreStaff } from "@/utils/base/staff";
import upload from "@/views/rdmanagement/components/database/upload.vue";

export default defineComponent({
  components: { upload },
  setup(props, context) {
    const user = useStore().state.user.user;
    const route = useRoute();
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
      record: null,
    });

    const formState = reactive({
      issue: null,
      annex: null,
    });

    const formRef = ref();

    // 上传文件
    const setUploadFileUrl = (url) => {
      formState.annex = url;
    };

    const showModal = (options) => {
      const { title, type, record } = options;
      modalConfig.visible = true;
      modalConfig.title = title;
      modalConfig.type = type;
      modalConfig.record = record;
    };

    const closeModal = () => {
      modalConfig.record = null;
      modalConfig.title = null;
      modalConfig.type = null;
      formState.issue = null;
      formState.annex = null;
      modalConfig.visible = false;
    };

    // websocket通知
    const websocketNotice = (person) => {
      const { id } = person;
      const query = Object.assign(
        {
          type: "link",
          activeKey: "设计变更",
          processName: modalConfig.record.processName,
        },
        route.query
      );

      const { nickName } = user;
      const localTime = timeStampToTime("", "upload");

      websocket.Send({
        content: `${modalConfig.record.promoter}在${localTime}推送${modalConfig.record.processName}审核`,
        query: JSON.stringify(query),
        route: "/rdprojectlayout",
        messageSort: "设计变更",
        toUserId: id.replace(/P/g, ""),
        type: 0,
        userId: user.id,
      });
    };

    const updateExamine = () => {
      updateDesignChanges({
        id: modalConfig.record.id,
        isEnd: true,
      });
    };

    const updateFile = () => {
      updateDesignChanges({
        id: modalConfig.record.id,
        annex: formState.annex,
      });
    };

    const handleOk = () => {
      const [record] = modalConfig.record.nodes.filter(
        (item) => item.nodeName === modalConfig.record.nodeName
      );

      const recordIndex = modalConfig.record.nodes.findIndex(
        (item) => item.nodeName === modalConfig.record.nodeName
      );
      record.notes = formState.issue;
      record.approved = modalConfig.type === "pass";
      record.approvalTime = timeStampToTime("", "upload");

      if (formState.annex) {
        updateFile();
      }

      saveApprovalNode(record)
        .then(async (res) => {
          if (!record.approved && modalConfig.record.nodes[recordIndex - 1]) {
            const content = modalConfig.record.nodes[recordIndex - 1];
            await getStrctreStaff(content.approver)
              .then((res) => {
                websocketNotice(res);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          // sokcet通知下一个
          if (
            record.approved &&
            recordIndex < modalConfig.record.nodes.length - 1
          ) {
            const content = modalConfig.record.nodes[recordIndex + 1];
            await getStrctreStaff(content.approver)
              .then((res) => {
                websocketNotice(res);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          // 抄送给采购
          if (
            recordIndex === modalConfig.record.nodes.length - 1 &&
            modalConfig.type === "pass"
          ) {
            updateExamine();
            await getEngineeringDepartment("采购部")
              .then((res) => {
                websocketNotice(res);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          context.emit("updateTable");
          closeModal();
        })
        .catch((err) => {});
    };

    const handleCancel = () => {
      closeModal();
    };

    return {
      setUploadFileUrl,
      modalConfig,
      handleOk,
      showModal,
      handleCancel,
      formState,
      formRef,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>